import { Coordinate } from "ol/coordinate";

export class StaticUtils {

  static convertToHourMinuteFormat(timeString: string): string {
    const [hours, minutes] = timeString.split('.').map(Number);
    return `${hours} h ${minutes} m`;
  }

  public ConvertToStringHoursMinutes(totalHours: number): string {
    // Calculate the number of hours
    const hours = Math.floor(totalHours);
    // Calculate the remaining minutes
    const minutes = ((totalHours - hours) * 60).toFixed(0)
    // Construct and return the resulting string

    return `${hours} h ${minutes} m`;
  }

  public ConvertToMinutes(totalHours: number): number {
    return totalHours * 60;
  }

  static enumToArray(enumObj: any, subIndex = 1): { label: string; value: any }[] {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))  // Filter out numeric keys if enum is numeric
      .map(key => ({ label: key.substring(subIndex) , value: enumObj[key] }));
  }

  public truncateString(inputString: string, maxLength: number): string {
    if (inputString.length <= maxLength) {
      return inputString;
    } else {
      return inputString.substring(0, maxLength) + '...';
    }
  }

  static doubleCoordinateArrayToString(arr: Coordinate[][]): string {
    let newString = '[[';

    arr.forEach((v, i, a) => {
      const lastIndex = v.length - 1;
      v.forEach((v2, i2, a2) => {
        newString += '[' + v2.toString() + ']';

        if (lastIndex != i2) {
          newString += ',';
        }
      })
    })

    newString += ']]';

    return newString;
  };

  static getDateFormat(currentLang: string): string {
    const dateFormatMap = {
      en: 'MM/dd/YYYY',
      fr: 'dd/MM/yyyy',
      es: 'dd/MM/yyyy'
    };

    return dateFormatMap[currentLang] || 'MM/DD/YYYY';

  }

  static getDatePickerDateFormat(currentLang: string): string {
    const dateFormatMap = {
      en: 'MM/DD/YYYY',
      fr: 'DD/MM/YYYY',
      es: 'DD/MM/YYYY'
    };

    return dateFormatMap[currentLang] || 'MM/DD/YYYY';

  }

  static getDateWithTimeFormat(currentLang: string): string {
    const dateTimeFormatMap = {
      en: 'MM/dd/yyyy HH:mm a',
      fr: 'dd/MM/yyyy HH:mm',
      es: 'dd/MM/yyyy HH:mm'
    };

    return dateTimeFormatMap[currentLang] || 'MM/dd/yyyy HH:mm';
  }


  static getDateTimeFormat(currentLang: string): Intl.DateTimeFormatOptions {
    const dateTimeFormatMap: { [key: string]: Intl.DateTimeFormatOptions } = {
      en: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      fr: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
      es: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      },
    };

    return dateTimeFormatMap[currentLang] || dateTimeFormatMap['en'];
  }

  static getTimeFormat(currentLang: string): Intl.DateTimeFormatOptions {
    const timeFormatMap: { [key: string]: Intl.DateTimeFormatOptions } = {
      en: {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      },
      fr: {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      },
      es: {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      },
    };

    return timeFormatMap[currentLang] || timeFormatMap['en'];
  }

  static formatDateToISO8601(date: Date, isStart: boolean): string {

    let time: string = isStart ? '0' : '59';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, time);
    const minutes = String(date.getMinutes()).padStart(2, time);
    const seconds = String(date.getSeconds()).padStart(2, time);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  }

  static getEnumValues<T>(enumType: T): string[] {
    return Object.keys(enumType)
      .filter(key => isNaN(Number(key)))
      .map(key => enumType[key as keyof T] as unknown as string);
  
  }
}